import { VueModule } from '@Foundation/utilities';
import BackToTop from './code/Scripts/components/back-to-top';

export default VueModule({
  components: {
    BackToTop
  }
});
